const CURRENCY_REGEX = /[^\d.-]/g

export const sanitizeCurrencyValue = (value?: string | number): string => {
  if (!value) return ''
  return value.toString().replace(CURRENCY_REGEX, '')
}

export const currencyToNumber = (value?: string | number): number => {
  if (!value) return 0
  const sanitizedValue = sanitizeCurrencyValue(value)
  return parseFloat(sanitizedValue) || 0
}

export const numberToCurrency = (
  value?: string | number,
  options?: Intl.NumberFormatOptions,
): string => {
  if (value === null || value === undefined || value === '') return ''

  const sanitizedValue =
    typeof value === 'string' ? currencyToNumber(value) : value

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    ...options,
  }).format(sanitizedValue)
}

export const currencyFromCents = (
  cents: number | null,
  options?: Intl.NumberFormatOptions,
): string =>
  cents === null
    ? '—'
    : numberToCurrency(cents / 100, { maximumFractionDigits: 0, ...options })

export const numberToCompactCurrency = (value: number): string => {
  const abs = Math.abs(value)
  if (abs >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`
  if (abs >= 1_000) return `$${(value / 1_000).toFixed(1)}k`
  return `$${value.toFixed(0)}`
}
